(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const containers = document.querySelectorAll('.js-rectangular-autogrid');

  // Exit on pages where the container does not exist.
  if (!containers) return;

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_rectangularAutoGrid = {
    attach: function attach(context) {

      $(once('promutuel_rectangularAutoGrid', containers, context)).each(function () {
        const container = this;
        fitTilesToRectangle(this);

        window.addEventListener('breakpointchange', event => {
          fitTilesToRectangle(container);
        });
      });
    }
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Utilities
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  /**
   * Durstenfeld (Fisher–Yates variant) in-place array shuffling.
   * https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array#answer-12646864
   */
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  /**
   *
   * @param {HTMLElement} container
   */
  function fitTilesToRectangle(container) {
    const tiles = [...container.children];

    // Reset all previously set styles.
    container.style.gridTemplateRows = '';
    container.style.gridAutoFlow = '';
    tiles.forEach(tile => tile.classList.remove('rectangular-autogrid__tile--double'));

    // Count grid columns, excluding 0-width ones.
    const gridWidth = getComputedStyle(container).gridTemplateColumns.replace('/ 0px/g', '').split(' ').length;
    // Compute the corresponding grid rows.
    const gridHeight = Math.ceil((tiles.length) / gridWidth);

    // Exit if there is not enough space to expand anything.
    if (gridHeight <= 1 || gridWidth <= 1) return;

    // Make sure tiles are laid out in columns, not rows.
    container.style.gridTemplateRows = `repeat(${gridHeight}, 1fr)`;
    container.style.gridAutoFlow = 'column';

    // Shuffle tiles.
    shuffle(tiles);
    tiles.forEach(tile => { container.insertAdjacentElement('beforeend', tile) });

    // Pick random columns to be expanded.
    const holes = gridWidth * gridHeight - tiles.length;
    // Get all columns.
    const colsToExpand = [...Array(gridWidth).keys()];
    // Randomly remove some until only the right amount is left.
    while (colsToExpand.length > holes) {
      colsToExpand.splice(Math.floor(Math.random() * colsToExpand.length), 1);
    }

    // Expand one tile per selected column.
    colsToExpand.forEach((col, i) => {
      // Get the index corresponding to the normal column "head".
      let tileIndex = gridHeight * col;
      // Shift by -1 for each previously-expanded tile (as it now takes 2 spots) to get the actual column head index.
      tileIndex -= i;
      // Randomly select a row, but not the last one.
      tileIndex += Math.floor(Math.random() * (gridHeight - 1));

      // Now expand the tile.
      tiles[tileIndex].classList.add('rectangular-autogrid__tile--double');
    });
  }
})(jQuery, Drupal, drupalSettings, once);
